import { HTTPService } from "../util/httpManager.js";
import { BaseDataSourceComponentProps } from "./baseComponentProps.js";
import { MultipleCheckBoxesField } from "./isTimeTextBox.js";
import React from "react";
export class MultipleCheckBoxes extends React.Component<MultipleCheckBoxesProps, any>{
    private _containerElementRef: any;

    constructor(props: MultipleCheckBoxesProps) {
        super(props);
        let buttons = [];
        if (Array.isArray(props.dataSource)) {
            buttons = props.dataSource;
        } else if (props.field.dataSourceUrl !== undefined && props.field.dataSourceUrl !== null && props.field.dataSourceUrl !== "") {
            this._loadButtons();
        }
        this.state = { buttons: buttons };
    }

    private _loadButtons = () => {
        HTTPService.get(this.props.field.dataSourceUrl)
            .then(data => {
                this.setState({ buttons: data });
                this.props.onDataLoaded(this.props.field, data);
            });
    }

    private _handleChange = (value, dataItem) => {
        const resultArray = Array.isArray(this.props.value) ? this.props.value : [];
        const idx = resultArray.indexOf(value)
        if (idx === -1) {
            resultArray.push(value);
        } else {
            resultArray.splice(idx, 1);
        }
        this.props.onChange(this.props.field, resultArray, dataItem);
    }

    componentDidUpdate(prevProps: MultipleCheckBoxesProps) {
        if (this.props.field.refreshDSOnRefChange && this.props.dataSource != prevProps.dataSource) {
            this.setState({ buttons: this.props.dataSource });
        }
    }

    render() {
        let buttons = this.state.buttons.map((b, i) => {
            const id = `ckb-${this.props.field.guid || this.props.field.name}-${i}`;
            return (
                <React.Fragment key={i}>
                    <label key={"2"} htmlFor={id} className="k-radio-label" style={{ marginRight: "10px", display: "block", marginBottom: "5px", width: "fit-content" }}>
                        <input style={{ marginRight: "5px" }} key={"1"} id={id} type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md k-valid" onChange={(e) => this._handleChange(b[this.props.field.dataValueField], b)} name={this.props.field.model}
                            value={b[this.props.field.dataValueField]} checked={this.props.value.indexOf(b[this.props.field.dataValueField]) !== -1} disabled={this.props.disabled} required={this.props.required} data-label={this.props.field.name} />
                        {b[this.props.field.dataTextField]}</label>
                </React.Fragment>
            );
        });

        return (
            <div className="multiple-checkBoxes__container" ref={(r) => this._containerElementRef = r}>{buttons}</div>
        );
    }
};
export interface MultipleCheckBoxesProps extends BaseDataSourceComponentProps {
    field: MultipleCheckBoxesField;
}